<ion-header class=ion-no-border>
    <ion-toolbar mode="ios">
        <ion-title>{{'BroadcastMessages' | translation}}</ion-title>
        <ion-buttons slot="end">
            <ion-button fill="clear" (click)="dismiss()">
                <ion-icon name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>
<!-- <ion-content>
    <ion-list>
        <ion-list-header>
            <h6 style="text-align: center;">{{'SelectedDisciples' | translation}}</h6>
        </ion-list-header>

        <ion-item *ngFor="let t of selectedItems;">
            <p>
                <span style="font-weight: bold; font-size: small;">{{t.seeker_name}}</span><br/>
                <small>{{t.seeker_language}}</small>
            </p>
        </ion-item>
    </ion-list>
</ion-content> -->

<ion-content class=ion-no-border translucent="false" style="max-height: 480px;">
    <div>
        <ion-grid class="pty-footer-grid custom-message-aree">
            <ion-row>
                <ion-col>
                    <ion-item>
                        <textarea style="width: 100%;" maxlength="100" [rows]="1" placeholder="{{'Subject' | translation}}" [(ngModel)]="subject_line"></textarea>
                    </ion-item>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col>
                    <textarea style="width: 100%;" maxlength="2000" [rows]="16" placeholder="{{'EnterMessage' | translation}}" [(ngModel)]="chatMessage"></textarea>
                </ion-col>
            </ion-row>
            <ion-row class="ion-justify-content-end ion-align-items-center">
                <ion-col size="9">
                    <span class="characterCountSpan">{{chatMessage.length}}/{{textLimit}}{{'Characters' | translation}}
                    </span>
                </ion-col>
                <ion-col size="1" class="pty-footer-col">
                    <ion-button class="pty-footer-button" expand="full" (click)="showMore($event)">
                        <ion-icon name="ellipsis-vertical-outline" size="md"></ion-icon>
                    </ion-button>
                </ion-col>
                <ion-col size="1" class="pty-footer-col">
                    <ion-button class="pty-footer-button" expand="full" (click)="sendMessage()" [disabled]=" ! chatMessage || chatMessage.length == 0">
                        <ion-icon name="send"></ion-icon>
                    </ion-button>
                </ion-col>
            </ion-row>
        </ion-grid>
    </div>
</ion-content>
